import { animate } from "motion";

export class ProjectAccordion {
	constructor() {
		this.items = document.querySelectorAll("[data-accordion]");
		if (!this.items.length) return;

		this.init();
		this.checkHash();
	}

	init() {
		this.items.forEach((item) => {
			const toggle = item.querySelector("[data-accordion-toggle]");
			const content = item.querySelector("[data-accordion-content]");

			if (!toggle || !content) return;

			toggle.addEventListener("click", () =>
				this.toggle(item, toggle, content)
			);
		});
	}

	checkHash() {
		const hash = location.hash.slice(1);
		if (!hash) return;

		// Check if hash matches a project ID
		const project = document.getElementById(hash);
		if (project && project.hasAttribute("data-accordion")) {
			const toggle = project.querySelector("[data-accordion-toggle]");
			const content = project.querySelector("[data-accordion-content]");

			if (toggle && content) {
				// Scroll to project
				setTimeout(() => {
					project.scrollIntoView({ behavior: "smooth", block: "start" });
				}, 100);

				// Expand it
				this.expand(project, toggle, content, false);
			}
		}
	}

	toggle(item, toggle, content) {
		const isExpanded = toggle.getAttribute("aria-expanded") === "true";

		if (isExpanded) {
			this.collapse(toggle, content);
		} else {
			this.expand(item, toggle, content, true);
		}

		// Notify other components that layout changed
		window.dispatchEvent(new CustomEvent("projects-filtered"));
	}

	expand(item, toggle, content, updateHash = true) {
		toggle.setAttribute("aria-expanded", "true");
		toggle.querySelector(".link__label").textContent = "Weniger anzeigen";
		toggle.querySelector(".link__icon").style.display = "none";

		content.hidden = false;

		// Get natural height
		const height = content.scrollHeight;

		animate(
			content,
			{ height: [0, height], opacity: [0, 1] },
			{ duration: 0.3, easing: [0.25, 0, 0.3, 1] }
		).finished.then(() => {
			content.style.height = "auto";
		});

		// Update URL hash
		if (updateHash && item.id) {
			history.replaceState(null, "", "#" + item.id);
		}
	}

	collapse(toggle, content) {
		toggle.setAttribute("aria-expanded", "false");
		toggle.querySelector(".link__label").textContent = "Mehr erfahren";
		toggle.querySelector(".link__icon").style.display = "";

		const height = content.scrollHeight;
		content.style.height = height + "px";

		animate(
			content,
			{ height: [height, 0], opacity: [1, 0] },
			{ duration: 0.3, easing: [0.25, 0, 0.3, 1] }
		).finished.then(() => {
			content.hidden = true;
			content.style.height = "";
		});

		// Clear hash on collapse
		history.replaceState(null, "", location.pathname);
	}
}
